import type { RadioData, RadioOption, Option, Options } from './types.tsx';

export const mapDataToOptions = (data: RadioData): Options =>
	data.map(({ id, value }) => ({ label: value, value: id }));

export const mapOptionToData = ({ label, value }: Option): RadioOption => ({
	id: value,
	value: label,
});
